import { checkCardNumberLength, checkCardDate, checkCardCVVlength } from "../utils/cardUtils";


const checkCardFormValidation = (field, errors) => {

    let isValid = true;
    let isErrors = errors;
    
    //Amount:
    if (field.amount === '' || field.amount === '0.00') {
        isErrors.amount = 'Amount should be greater than 0.'
        isValid = false;
    } else if (Number(field.amount.replace(/,/g, "")) > 30000 ) {
        isErrors.amount = 'Amount should be too larger.'
        isValid = false;
    } else {
        isErrors.amount = '';
    }

    //name on card:
    if(field.nameOnCard.trim() === ''){
        isErrors.nameOnCard = 'Name on card is required.';
        isValid = false;
    } else {
        isErrors.nameOnCard = '';
    }
    
    // Mobile No:
    if(field.mobileNo.trim() === ''){
        isErrors.mobileNo = 'Mobile number is required.';
        isValid = false;
    } else if((field.mobileNo.replace(/\D/g, '')).length !== 10){
        isErrors.mobileNo = 'Mobile number must be 10 digit.';
        isValid = false;
    } else {
        isErrors.mobileNo = '';
    }

    //CardNumber:
    if (field.cardNumber.replace(/\s+/g, '').length === 0) {
        isErrors.cardNumber = 'Card number is required.'
        isValid = false;
    } else if (field.cardNumber.replace(/\s+/g, '').length > 0 && field.cardNumber.replace(/\s+/g, '').length < 20) {
        let isValidLength = checkCardNumberLength(field.cardType, field.cardNumber.replace(/\s+/g, '').length);
        if (isValidLength) {
            isErrors.cardNumber = '';
        } else {
            isErrors.cardNumber = 'Card number is invalid.';
            isValid = false;
        }
    } else if (field.cardType === 'default') {
        isErrors.cardNumber = 'Card number is invalid.';
        isValid = false;
    } else {
        isErrors.cardNumber = ''
    }

    //Expire-Date
    if (field.expirationDate === '') {
        isErrors.expirationDate = 'Expiration date is required.'
        isValid = false;
    } else if (field.expirationDate.length < 5) {
        isErrors.expirationDate = 'Expiration date is invalid.'
        isValid = false;
    } else if (field.expirationDate.length === 5) {
        const valid = checkCardDate(field.expirationDate);
        if (!valid) {
            isErrors.expirationDate = 'Expiration date is invalid.';
            isValid = false;
        } else {
            isErrors.expirationDate = '';
        }
    } else {
        isErrors.expirationDate = '';
    }

    //CVV:
    if (field.cvv === '') {
        isErrors.cvv = 'CVV is required.';
        isValid = false;
    } else if (field.cvv.length > 0 && field.cvv.length < 5) {

        const valid = checkCardCVVlength(field.cardType, field.cvv.length);
        if (!valid) {
            isErrors.cvv = 'CVV is invalid.';
            isValid = false;
        } else {
            isErrors.cvv = '';
        }
    } else {
        isErrors.cvv = '';
    }

    //Address:
    if (field.address1 === '') {
        isErrors.address1 = 'Billing address is required.';
        isValid = false;
    } else {
        isErrors.address1 = '';
    }

    //State:
    if(field.state === ''){
        isErrors.state = 'Please select billing state.';
        isValid = false;
    } else {
        isErrors.state = ''
    }

    //Postal-Code
    if (field.postalCode === '') {
        isErrors.postalCode = 'Billing zip/postal code is required.';
        isValid = false;
    } else if (field.postalCode.length < 5) {
        isErrors.postalCode = 'Billing zip/postal code is invalid.';
        isValid = false;
    } else {
        isErrors.postalCode = '';
    }
    
    //Email:
    if(field.email.trim().length === 0 ){
        isErrors.email = 'Email is required.';
        isValid = false;
    } else if(!field.email.trim().match(new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/))){
         isErrors.email = 'Email is invalid.';
        isValid = false;
    }  else {
        isErrors.email = '';
    }

    //Receipt Email:
    if(field.receiptEmails.trim().length > 0 ){

        const emailList = field.receiptEmails.trim().split(',');
        const newList = emailList.map((email) => {
            return email.trim();
        });
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        
        // check every email valid
        const areAllValid = newList.every(email => {
            const singleEmail = email.trim();
            return singleEmail.length > 0 && emailRegex.test(singleEmail);
        });

        //check duplicate email:
        const uniqueEmails = new Set(newList);
        const hasDuplicates = uniqueEmails.size !== newList.length;
        const duplicateWithMainEmail = newList.includes(field.email.trim());

        if(newList.length > 5){
            isErrors.receiptEmails = "Only add maximum 5 additional receipt emails.";
            isValid = false;
        } else if(duplicateWithMainEmail){
            isErrors.receiptEmails = "Additional receipt email duplicate with primary email.";
            isValid = false;
        } else if (!areAllValid) {
            isErrors.receiptEmails = "Additional receipt emails are invalid.";
            isValid = false;
        } else if(hasDuplicates){
            isErrors.receiptEmails = "Duplicate additional emails are not allowed.";
            isValid = false;
        } else {
            isErrors.receiptEmails = '';
        }
    } else {
        isErrors.receiptEmails = '';
    }

    //for reset threeds error:
    isErrors.threeDs = '';



    return { isValid, isErrors };
}

export default checkCardFormValidation;